<template>
  <div class="storeCoupons">
    <!-- 商家发券页：展示商家列表，支持发券，并可跳转到对应商家的发券记录页。 -->
    <!-- 筛选区沿用住户管理页的查询条件，小区切换后会联动刷新楼栋、单元、房间、车场和列表数据。 -->
    <div class="filters">
      <el-form :inline="true">
        <el-form-item>
          <el-date-picker
            v-model="datevalues"
            type="daterange"
            :range-separator="$t('lang.lab_to')"
            :start-placeholder="'注册' + $t('lang.lab_startDate')"
            :end-placeholder="'注册' + $t('lang.lab_endDate')"
            value-format="timestamp"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="floorid" @change="selectUnit">
            <el-option key :label="$t('lang.lab_floorName')" value=""></el-option>
            <el-option
              v-for="(item, index) in floorList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="unitid" @change="selectRoom">
            <el-option key :label="$t('lang.lab_unitName')" value=""></el-option>
            <el-option
              v-for="(item, index) in unitList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="roomid">
            <el-option key :label="$t('lang.lab_roomName')" value=""></el-option>
            <el-option
              v-for="(item, index) in roomList"
              :key="index"
              :value="item.id"
              :label="item.name"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            class="select"
            v-model="user"
            :placeholder="$t('lang.APPHOUSEHOLDMANAGE.USERTYPE[0].label')"
          >
            <el-option
              v-for="item in Identitys"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select
            class="select"
            v-model="draw"
            :placeholder="$t('lang.APPHOUSEHOLDMANAGE.TAGS[0].label')"
            @change="changeDraw($event)"
          >
            <el-option
              v-for="item in tags"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-input
            v-if="showQt"
            class="searchInput"
            v-model="qt"
            placeholder="请输入标签内容"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-input
            class="searchInput"
            v-model="keyword"
            :placeholder="$t('lang.lab_please_Input') + $t('lang.lab_username')"
          ></el-input>
        </el-form-item>
        <el-button type="primary" @click="submit()">{{ $t('lang.btn_search') }}</el-button>
      </el-form>
    </div>

    <!-- 列表区仅展示商家用户数据，操作列只保留发券和发券记录两个入口。 -->
    <el-card>

      <el-table
        :data="tableData"
        class="wid100"
        :height="
          tableData.length > 0
            ? require('@/config/enum').tableheight529
            : require('@/config/enum').tableheight109
        "
        :row-class-name="tableRowClassName"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          v-if="appHouseholdManageListcheckbox"
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          type="index"
          :index="indexMethod"
          align="center"
          :label="$t('lang.lab_index')"
          width="100px"
        ></el-table-column>
        <el-table-column prop="nickName" :label="$t('lang.lab_username')"></el-table-column>
        <el-table-column prop="mobile" :label="$t('lang.lab_phone')"></el-table-column>
        <el-table-column prop="garden.name" :label="$t('lang.lab_village')"></el-table-column>
        <el-table-column
          prop="garden.grids.houseName"
          :label="$t('lang.lab_buildingnum')"
        ></el-table-column>
        <el-table-column
          prop="garden.grids.unitName"
          :label="$t('lang.lab_unitnum')"
        ></el-table-column>
        <el-table-column
          prop="garden.grids.roomName"
          :label="$t('lang.lab_roomnum')"
        ></el-table-column>
        <el-table-column prop="garden.userType" :label="$t('lang.lab_identitynum')">
          <template slot-scope="scope">
            <span v-if="scope.row.garden && scope.row.garden.userType === 1">
              {{ $t('lang.APPHOUSEHOLDMANAGE.USERTYPE[1].label') }}
            </span>
            <span v-if="scope.row.garden && scope.row.garden.userType === 2">
              {{ $t('lang.APPHOUSEHOLDMANAGE.USERTYPE[2].label') }}
            </span>
            <span v-if="scope.row.garden && scope.row.garden.userType === 3">
              {{ $t('lang.APPHOUSEHOLDMANAGE.USERTYPE[3].label') }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="draw" :label="$t('lang.lab_tags')">
          <template slot-scope="scope" v-if="scope.row.drawUserGarden != ''">
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.drawUserGarden && scope.row.drawUserGarden.length > 30"
              :disabled="false"
            >
              <div slot="content">
                <span>{{ scope.row.drawUserGarden }}</span>
              </div>
              <div>
                {{ scope.row.drawUserGarden.substring(0, 30) | valueIsNull }}
                <span v-if="scope.row.drawUserGarden.length > 30">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.drawUserGarden | valueIsNull }}</div>
            </el-tooltip>
          </template>
          <template slot-scope="scope" v-else>
            <el-tooltip
              placement="top"
              effect="light"
              v-if="scope.row.draw && scope.row.draw.length > 30"
              :disabled="false"
            >
              <div slot="content">
                <span>{{ scope.row.draw }}</span>
              </div>
              <div>
                {{ scope.row.draw.substring(0, 30) | valueIsNull }}
                <span v-if="scope.row.draw.length > 30">...</span>
              </div>
            </el-tooltip>
            <el-tooltip placement="top" effect="light" v-else :disabled="true">
              <div>{{ scope.row.draw | valueIsNull }}</div>
            </el-tooltip>
          </template>
        </el-table-column>
        <el-table-column
          prop="staffName"
          :label="$t('lang.lab_housekeeper')"
          width="200"
        ></el-table-column>
        <el-table-column
          prop="operation"
          :label="$t('lang.lab_operation')"
          width="220"
          fixed="right"
        >
          <template slot-scope="scope">
            <el-button @click="openCouponDialog(scope.row)">发券</el-button>
            <el-button @click="goCouponHistory(scope.row)">发券记录</el-button>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNo"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next, jumper"
        :page-count="pageCount"
      />
    </el-card>

    <!-- 发券弹窗：parkId 放在表单内选择，couponType 会联动 reduceMinutes 的校验与默认值。 -->
    <el-dialog
      title="发券"
      :visible.sync="couponDialogVisible"
      :close-on-click-modal="false"
      center
      top="130px"
      width="600px"
      @closed="handleCouponDialogClosed"
    >
      <el-form
        ref="couponForm"
        :model="couponForm"
        :rules="couponRules"
        :label-width="require('@/config/enum').c_ws4"
        :label-suffix="require('@/config/enum').c_colon"
      >
        <el-form-item label="券名称" prop="couponName">
          <el-input
            v-model.trim="couponForm.couponName"
            maxlength="50"
            placeholder="请输入券名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="车场" prop="parkId">
          <el-select
            v-model="couponForm.parkId"
            class="select wid100"
            placeholder="请选择车场"
            :disabled="parkList.length === 0"
          >
            <el-option
              v-for="item in parkList"
              :key="item.id"
              :label="item.parkName"
              :value="item.id"
            ></el-option>
          </el-select>
          <div v-if="parkList.length === 0" class="form-tip">当前小区未配置车场</div>
        </el-form-item>
        <el-form-item label="券类型" prop="couponType">
          <el-select
            v-model="couponForm.couponType"
            class="select wid100"
            placeholder="请选择券类型"
            @change="handleCouponTypeChange"
          >
            <el-option label="时长减免" :value="1"></el-option>
            <el-option label="次数减免" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="减免分钟数" prop="reduceMinutes">
          <el-input-number
            v-model="couponForm.reduceMinutes"
            class="wid100"
            :min="couponForm.couponType === 1 ? 30 : 0"
            :step="30"
            :precision="0"
            :controls="true"
            :disabled="couponForm.couponType === 2"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="发券总数" prop="grantCount">
          <el-input-number
            v-model="couponForm.grantCount"
            class="wid100"
            :min="1"
            :step="1"
            :precision="0"
            :controls="true"
          ></el-input-number>
        </el-form-item>
        <el-form-item label="生效开始时间" prop="startTime">
          <el-date-picker
            v-model="couponForm.startTime"
            class="wid100"
            type="datetime"
            value-format="timestamp"
            placeholder="请选择生效开始时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="生效结束时间" prop="endTime">
          <el-date-picker
            v-model="couponForm.endTime"
            class="wid100"
            type="datetime"
            value-format="timestamp"
            placeholder="请选择生效结束时间"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input
            v-model.trim="couponForm.remark"
            type="textarea"
            :rows="3"
            maxlength="200"
            show-word-limit
            placeholder="请输入备注"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="couponDialogVisible = false">{{ $t('lang.btn_cancel') }}</el-button>
        <el-button type="primary" @click="saveCoupon">{{ $t('lang.btn_save') }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

// 商家发券页：负责商家列表查询、车场缓存、发券表单提交以及记录页跳转。
export default {
  name: '/manage/main.storeCoupons',
  data() {
    // 时长券要求减免分钟数必填、为整数且最小 30；次数券不在这里拦截，统一按 0 提交。
    const validateReduceMinutes = (rule, value, callback) => {
      if (this.couponForm.couponType === 2) {
        callback()
        return
      }
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入减免分钟数'))
        return
      }
      if (!Number.isInteger(value)) {
        callback(new Error('减免分钟数必须为整数'))
        return
      }
      if (value < 30) {
        callback(new Error('减免分钟数最小为30'))
        return
      }
      callback()
    }
    // 发券总数必须为正整数。
    const validateGrantCount = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请输入发券总数'))
        return
      }
      if (!Number.isInteger(value) || value <= 0) {
        callback(new Error('发券总数必须为正整数'))
        return
      }
      callback()
    }
    // 结束时间必须晚于开始时间，时间组件统一按时间戳提交。
    const validateEndTime = (rule, value, callback) => {
      if (value === '' || value === null || value === undefined) {
        callback(new Error('请选择生效结束时间'))
        return
      }
      if (
        this.couponForm.startTime !== '' &&
        this.couponForm.startTime !== null &&
        this.couponForm.startTime !== undefined &&
        value <= this.couponForm.startTime
      ) {
        callback(new Error('生效结束时间必须大于开始时间'))
        return
      }
      callback()
    }

    return {
      // 列表筛选条件与表格选择状态。
      multipleSelection: [],
      datevalues: [],
      floorid: '',
      floorList: [],
      unitid: '',
      unitList: [],
      roomid: '',
      roomList: [],
      user: '0',
      tag: '',
      draw: '',
      qt: '',
      showQt: false,
      keyword: '',
      // 列表分页与楼栋树查询辅助状态。
      pageCount: 0,
      pageNo: 1,
      pageSize: 10,
      tableData: [],
      type: 1,
      parentId: '',
      Identitys: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.USERTYPE'),
      tags: this.$i18n.t('lang.APPHOUSEHOLDMANAGE.TAGS'),
      appHouseholdManageListcheckbox: require('@/config/enum').appHouseholdManageListcheckbox,
      // 页面初始化时缓存当前小区下的车场列表；仅有一个车场时自动带入默认值。
      parkList: [],
      defaultParkId: '',
      // 发券弹窗状态以及当前发券目标商家。
      couponDialogVisible: false,
      currentUserId: '',
      // 发券表单模型与校验规则。
      couponForm: {
        couponName: '',
        couponType: 1,
        reduceMinutes: 30,
        grantCount: 1,
        startTime: '',
        endTime: '',
        remark: '',
        parkId: '',
      },
      couponRules: {
        couponName: [
          { required: true, message: '请输入券名称', trigger: 'blur' },
        ],
        parkId: [
          { required: true, message: '请选择车场', trigger: 'change' },
        ],
        couponType: [
          { required: true, message: '请选择券类型', trigger: 'change' },
        ],
        reduceMinutes: [
          { required: true, validator: validateReduceMinutes, trigger: 'change' },
        ],
        grantCount: [
          { required: true, validator: validateGrantCount, trigger: 'change' },
        ],
        startTime: [
          { required: true, message: '请选择生效开始时间', trigger: 'change' },
        ],
        endTime: [
          { required: true, validator: validateEndTime, trigger: 'change' },
        ],
      },
    }
  },
  created() {
    this.initPage()
  },
  computed: {
    ...mapGetters(['gardenId']),
  },
  watch: {
    // 小区切换后，重置筛选和弹窗状态，并重新拉取楼栋、车场和商家列表。
    gardenId() {
      this.gardenChange()
    },
    // 开始时间变化后，立即触发结束时间字段重新校验。
    'couponForm.startTime'() {
      if (this.$refs.couponForm) {
        this.$refs.couponForm.validateField('endTime')
      }
    },
  },
  methods: {
    // 页面首次进入时加载商家列表、楼栋树以及车场缓存。
    initPage() {
      this.parentId = this.gardenId
      this.topics()
      this.gardenGrids(this.gardenId)
      this.getParkList(this.gardenId)
    },
    // “其他”标签需要额外填写标签内容。
    changeDraw(e) {
      if (e === '其他') {
        this.showQt = true
      } else {
        this.qt = ''
        this.showQt = false
      }
    },
    indexMethod(index) {
      return (this.pageNo - 1) * this.pageSize + index + 1
    },
    tableRowClassName({ rowIndex }) {
      return rowIndex % 2 === 0 ? 'row-dark' : ''
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 小区切换时同步重置筛选、弹窗、车场默认值与列表数据。
    gardenChange() {
      this.floorid = ''
      this.unitid = ''
      this.roomid = ''
      this.unitList = []
      this.roomList = []
      this.type = 1
      this.pageNo = 1
      this.parentId = this.gardenId
      this.couponDialogVisible = false
      this.resetCouponForm()
      this.gardenGrids(this.gardenId)
      this.getParkList(this.gardenId)
      this.topics()
    },
    // 查询楼栋/单元/房间级联数据，type 决定当前拉取的是哪一层级。
    gardenGrids(parentId) {
      let loading = this.$loading()
      this.$get(`/gardenGrids?type=${this.type}&parentId=${parentId}&pageNo=1&pageSize=999`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            if (this.type === 1) {
              this.floorList = res.list
            } else if (this.type === 2) {
              this.unitList = res.list
              this.roomList = []
              if (this.floorid === '') {
                this.unitList = []
                this.roomList = []
              }
            } else if (this.type === 3) {
              this.roomList = res.list
              if (this.unitid === '') {
                this.roomList = []
              }
            }
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 页面进入或小区切换时只拉一次车场列表，供发券弹窗直接复用。
    getParkList(gardenId) {
      let loading = this.$loading()
      this.$get(`/carPark?pageNo=1&pageSize=999&gardenId=${gardenId}`).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.parkList = res.list || []
            // 当前小区只有一个车场时，打开弹窗直接默认带入，减少手动选择。
            this.defaultParkId = this.parkList.length === 1 ? this.parkList[0].id : ''
          }
        },
        error => {
          loading.close()
          this.parkList = []
          this.defaultParkId = ''
          this.$message.error(error)
        }
      )
    },
    // 查询商家列表，接口参数沿用住户管理页，并额外固定带 isShop=1 过滤商家用户。
    topics() {
      if (this.draw === '其他' && this.qt === '') {
        this.$message.info('请输入标签内容')
        return false
      }
      let startTs = ''
      let endTs = ''
      if (this.datevalues != null && this.datevalues.length > 0) {
        startTs = this.datevalues[0]
        endTs = this.datevalues[1]
      }
      let loading = this.$loading()
      this.$get(
        `/users?pageNo=${this.pageNo}&pageSize=${this.pageSize}&gardenId=${this.gardenId}&houseId=${this.floorid}&unitId=${this.unitid}&roomId=${this.roomid}&userType=${this.user}&key=${this.keyword}&tagId=${this.tag}&startTs=${startTs}&endTs=${endTs}&draw=${this.draw}&qt=${this.qt}&isShop=1`
      ).then(
        res => {
          loading.close()
          if (res && res.errCode === 0) {
            this.tableData = res.list
            this.pageCount = res.pageCount
          }
        },
        error => {
          loading.close()
          this.$message.error(error)
        }
      )
    },
    // 打开发券弹窗时记录当前商家 userId，并根据车场缓存回填默认 parkId。
    openCouponDialog(row) {
      this.couponDialogVisible = true
      this.resetCouponForm()
      this.currentUserId = row.id
      if (this.defaultParkId !== '') {
        this.couponForm.parkId = this.defaultParkId
      }
      this.$nextTick(() => {
        if (this.$refs.couponForm) {
          this.$refs.couponForm.clearValidate()
        }
      })
    },
    // 切换券类型时同步处理减免分钟数：次数券固定为 0，时长券至少为 30。
    handleCouponTypeChange(val) {
      if (val === 2) {
        this.couponForm.reduceMinutes = 0
      } else if (this.couponForm.reduceMinutes < 30 || this.couponForm.reduceMinutes === 0) {
        this.couponForm.reduceMinutes = 30
      }
      this.$nextTick(() => {
        if (this.$refs.couponForm) {
          this.$refs.couponForm.validateField('reduceMinutes')
        }
      })
    },
    // 关闭或重新打开弹窗前重置表单，避免残留上一次发券数据。
    resetCouponForm() {
      this.couponForm = {
        couponName: '',
        couponType: 1,
        reduceMinutes: 30,
        grantCount: 1,
        startTime: '',
        endTime: '',
        remark: '',
        parkId: this.defaultParkId,
      }
      this.$nextTick(() => {
        if (this.$refs.couponForm) {
          this.$refs.couponForm.clearValidate()
        }
      })
    },
    // 弹窗关闭后清空当前商家上下文。
    handleCouponDialogClosed() {
      this.resetCouponForm()
      this.currentUserId = ''
    },
    // 提交发券表单，调用 POST /carCouponMerchant 并附带 gardenId、parkId、userId。
    saveCoupon() {
      if (this.parkList.length === 0) {
        this.$message.warning('当前小区未配置车场')
        return
      }
      this.$refs.couponForm.validate(valid => {
        if (!valid) {
          return false
        }
        let params = {
          couponName: this.couponForm.couponName,
          couponType: this.couponForm.couponType,
          // 次数券后端固定接收 0，避免误传时长字段。
          reduceMinutes: this.couponForm.couponType === 2 ? 0 : this.couponForm.reduceMinutes,
          grantCount: this.couponForm.grantCount,
          startTime: this.couponForm.startTime,
          endTime: this.couponForm.endTime,
          remark: this.couponForm.remark,
          gardenId: this.gardenId,
          parkId: this.couponForm.parkId,
          userId: this.currentUserId,
        }
        let loading = this.$loading()
        this.$post('/carCouponMerchant', params).then(
          res => {
            loading.close()
            if (res && res.errCode === 0) {
              this.$message.success(this.$i18n.t('lang.lab_save_success'))
              this.couponDialogVisible = false
            }
          },
          error => {
            loading.close()
            this.$message.error(error)
          }
        )
      })
    },
    // 跳转到当前商家的发券记录页，透传 userId 和 gardenId 作为查询条件。
    goCouponHistory(row) {
      this.$router.push({
        name: 'storeCouponsHistory',
        query: {
          userId: row.id,
          gardenId: this.gardenId,
        },
      })
    },
    // 重置分页后按当前筛选条件重新查询。
    submit() {
      this.pageNo = 1
      this.topics()
    },
    // 楼栋变化后清空下级单元、房间并重新查询单元列表。
    selectUnit() {
      this.type = 2
      this.gardenGrids(this.floorid)
      this.unitid = ''
      this.roomid = ''
    },
    // 单元变化后清空房间并重新查询房间列表。
    selectRoom() {
      this.type = 3
      this.gardenGrids(this.unitid)
      this.roomid = ''
    },
    handleCurrentChange(val) {
      this.pageNo = val
      this.topics()
    },
    handleSizeChange(val) {
      this.pageNo = 1
      this.pageSize = val
      this.topics()
    },
  },
}
</script>

<style lang="scss">
/* 发券页只保留当前页面需要的基础样式，车场缺失提示与记录页保持一致。 */
.storeCoupons {
  .wid100 {
    width: 100%;
  }

  .form-tip {
    color: #f56c6c;
    line-height: 20px;
    font-size: 12px;
  }
}
</style>
